export const contentIdentifier = {
  input: {
    identifier: "Unique identifier"
  }
};
